import Carousel from './Carousel';

export default function initCarousels () {

	const carouselElements = document.getElementsByClassName('js-carousel');

	for (const element of carouselElements) {

		if (element.classList.contains('lazyloaded') || !element.classList.contains('lazyload')) {

			const carousel = new Carousel(element);
			if (carousel.slider) {
				carousel.slider.mount();
			}

		}

	}

	document.addEventListener(
		'lazybeforeunveil',
		(e) => {

			if (e.target.classList.contains('js-carousel')) {

				const carousel = new Carousel(e.target);
				if (carousel.slider) {
					carousel.slider.mount();
				}

			}

		}
	);

}
